import { layoutTargets } from './layoutTargets';
import { preview } from './preview';

export const AdjacentBottomOnly = {
  layoutTargets,
  preview,
};
